

const BASE = 'https://mc-heads.net';

export function avatarUrl(username, size) {
  const name = encodeURIComponent(username || 'Steve');
  return size ? `${BASE}/avatar/${name}/${size}` : `${BASE}/avatar/${name}`;
}

export function bodyUrl(username, size) {
  const name = encodeURIComponent(username || 'Steve');
  return size ? `${BASE}/body/${name}/${size}` : `${BASE}/body/${name}`;
}


export function headUrl(texture, size) {
  const hash = encodeURIComponent(texture);
  return size ? `${BASE}/head/${hash}/${size}` : `${BASE}/head/${hash}`;
}
